import type {GroupId, RecipeEntry, RecipeId} from "../../models/GroupRepo";
import {getStorageKey} from "../../storage";
import {createReactiveLocalStoreByKey} from "../../utils/create-reactive-local-store";

export const [usePotlist, setPotlist, {getValue}] = createReactiveLocalStoreByKey({
  keyToStorageKey: (groupId: GroupId) => getStorageKey.potlist(groupId),
});

export const addToPotlist = (groupId: GroupId, recipe: RecipeEntry) => {
  const potlist = getValue(groupId);
  setPotlist(groupId, {
    ...potlist,
    [recipe.id]: {portionCount: recipe.defaultPortions},
  });
};

export const removeFromPotlist = (groupId: GroupId, recipeId: RecipeId) => {
  const potlist = getValue(groupId);
  if (!potlist) return;
  const cpy = {...potlist};
  delete cpy[recipeId];
  setPotlist(groupId, cpy);
};

export const setPotlistPortionCount = (
  groupId: GroupId,
  recipeId: RecipeId,
  portionCount: number
) => {
  const potlist = getValue(groupId);
  if (!potlist) return;
  const cpy = {...potlist};
  cpy[recipeId] = {...cpy[recipeId], portionCount};
  setPotlist(groupId, cpy);
};

export const clearPotlist = (groupId: GroupId) => {
  setPotlist(groupId, {});
};
